const checkNewsletterForm = () => {
  if (0 < inputText.value.length && checkbox.checked) {
    //入力された文字が5文字以上なら実行される
    button.disabled = false;
  } else {
    button.disabled = true;
  }
}
const checkNewsletterForm2 = () => {
  if (0 < inputText2.value.length && checkbox2.checked) {
    //入力された文字が5文字以上なら実行される
    button2.disabled = false;
  } else {
    button2.disabled = true;
  }
}

let inputText = document.getElementById('input-email');
let inputText2 = document.getElementById('input-email2');
let checkbox = document.getElementById('check-pp');
let checkbox2 = document.getElementById('check-pp2');
let checkboxLabel = document.getElementById('checkboxLabel');
let button = document.getElementById('subscribe');
let button2 = document.getElementById('subscribe2');
checkNewsletterForm();
checkNewsletterForm2();
inputText.addEventListener('keyup', (e) => {
  checkNewsletterForm();
  checkboxLabel.classList.remove('disabled')
  button.classList.remove('disabled')
  button2.classList.remove('disabled')
})
checkbox.addEventListener('change',() => {
  checkNewsletterForm();
});
checkbox2.addEventListener('change',() => {
  checkNewsletterForm2();
});

const clickSubscribe = () => {
  button.innerText = "登録中"
  button2.innerText = "登録中"
}

// 海外の場合、valueにforeignを入れる
const addForeign = () => {
  const newsletterEl = document.querySelectorAll('[value="newsletter"]');
  if (newsletterEl.length > 0) {
    newsletterEl.forEach((el) => {
      el.value = "newsletter, foreign, registration_mail_footer";
    });
  }
}

const addTag = () => {
  const newsletterEl = document.querySelectorAll('[value="newsletter"]');
  if (newsletterEl.length > 0) {
    newsletterEl.forEach((el) => {
      el.value = "newsletter, registration_mail_footer";
    });
  }
}

if(window.location.href.includes("en.moln.com")) {
  console.log("foreign in newsletter value")
  addForeign();
} else {
  console.log("not foreign in newsletter value")
  addTag();
}